import { faTrash } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage, useIntl } from 'react-intl';

import { FontAwesomeIcon } from 'atoms/icons';
import { LoadingIndicator } from 'atoms/loader/LoadingIndicator';
import { Tooltip } from 'atoms/tooltip/Tooltip';
import { BodyM, LabelM } from 'atoms/typography';
import { ButtonWithConfirmDialog } from 'components/form/ButtonWithConfirmDialog';
import { fantasy, glossary } from 'lib/glossary';

import { LineupActionCta } from '../LineupActionCta';

type Props = {
  showLoader: boolean;
  onDelete: () => void;
};

export const DeleteCta = ({ showLoader, onDelete }: Props) => {
  const { formatMessage } = useIntl();
  return (
    <Tooltip
      title={
        <LabelM>
          <FormattedMessage
            id="Lobby.LineupActions.Tooltip.Delete"
            defaultMessage="Delete your lineup"
          />
        </LabelM>
      }
      placement="top-end"
    >
      <ButtonWithConfirmDialog
        size="large"
        color="tertiary"
        onConfirm={onDelete}
        message={
          <BodyM bold className="text-center">
            {formatMessage(fantasy.confirmDelete)}
          </BodyM>
        }
        component={LineupActionCta}
        aria-label={formatMessage(glossary.delete)}
      >
        {showLoader ? (
          <LoadingIndicator smaller />
        ) : (
          <FontAwesomeIcon icon={faTrash} />
        )}
      </ButtonWithConfirmDialog>
    </Tooltip>
  );
};
